// Vivid Glass Design System v5.2 — shared constants for brandDnaScreen
export const V = {
  // Core palette
  primary: '#FF7E67',
  accent: '#FF4D8D',
  info: '#38BDF8',
  warning: '#FFD222',
  purple: '#4F3A7D',
  // Text
  text: '#FFFFFF',
  textSub: '#94A3B8',
  textMuted: '#64748B',
  // Glass surfaces
  glass: 'rgba(255,255,255,0.06)',
  glassHover: 'rgba(255,255,255,0.08)',
  glassBorder: 'rgba(255,255,255,0.15)',
  glassBorderHover: 'rgba(255,255,255,0.30)',
  // Backgrounds
  bg: '#050505',
  bgGradient: 'radial-gradient(ellipse at top left, #1A0B2E 0%, #050505 60%)',
  font: 'Inter, sans-serif',
};

export const cardStyle = {
  borderRadius: 24,
  background: V.glass,
  border: `1px solid ${V.glassBorder}`,
  backdropFilter: 'blur(16px)',
  WebkitBackdropFilter: 'blur(16px)',
  padding: 24,
  transition: 'background 0.2s, border-color 0.2s',
};

// Use with onMouseEnter/Leave in a component
export const cardHoverStyle = {
  background: 'rgba(255,255,255,0.08)',
  border: '1px solid rgba(255,255,255,0.30)',
};

export const primaryBtnStyle = {
  display: 'inline-flex', alignItems: 'center', gap: 8,
  padding: '10px 20px', borderRadius: 12,
  background: 'linear-gradient(90deg,#FF7E67,#FF4D8D)',
  border: 'none', color: '#fff', fontSize: 14, fontWeight: 700,
  cursor: 'pointer', fontFamily: V.font,
};

// Secondary / asset buttons — purple per design system
export const secondaryBtnStyle = {
  display: 'inline-flex', alignItems: 'center', gap: 8,
  padding: '8px 16px', borderRadius: 12,
  background: 'rgba(79,58,125,0.5)', border: '1px solid #4F3A7D',
  color: '#C4B5FD', fontSize: 13, fontWeight: 600,
  cursor: 'pointer', fontFamily: V.font,
};

export const ghostBtnStyle = {
  display: 'inline-flex', alignItems: 'center', gap: 8,
  padding: '8px 16px', borderRadius: 12,
  background: 'transparent', border: 'rgba(255,255,255,0.10)',
  color: V.textSub, fontSize: 13, fontWeight: 500,
  cursor: 'pointer', fontFamily: V.font,
};

export const overlayStyle = {
  position: 'fixed', inset: 0, zIndex: 1000,
  background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(8px)',
  WebkitBackdropFilter: 'blur(8px)',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  padding: 24,
};

export const modalStyle = {
  borderRadius: 24, padding: 28,
  background: 'rgba(10,4,20,0.97)',
  border: `1px solid ${V.glassBorder}`,
  backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)',
  boxShadow: '0 24px 60px rgba(0,0,0,0.7)',
  width: '100%', maxWidth: 520,
  maxHeight: '85vh', overflowY: 'auto',
};

// Typography helpers
export const labelStyle = {
  fontSize: 10, fontWeight: 900, color: V.textMuted,
  textTransform: 'uppercase', letterSpacing: '1.5px',
  display: 'block', marginBottom: 6, fontFamily: V.font,
};

export const h2Style = {
  fontSize: 18, fontWeight: 600, color: V.text,
  margin: 0, fontFamily: V.font,
};

const AVATAR_GRADIENTS = [
  'linear-gradient(135deg,#667eea,#764ba2)',
  'linear-gradient(135deg,#f093fb,#f5576c)',
  'linear-gradient(135deg,#4facfe,#00f2fe)',
  'linear-gradient(135deg,#43e97b,#38f9d7)',
  'linear-gradient(135deg,#fa709a,#fee140)',
  'linear-gradient(135deg,#a18cd1,#fbc2eb)',
  'linear-gradient(135deg,#fccb90,#d57eeb)',
];

export const avatarGradient = (name = '') =>
  AVATAR_GRADIENTS[(name.charCodeAt(0) || 0) % AVATAR_GRADIENTS.length];

export const formatRelative = (ts) => {
  if (!ts) return '';
  const diff = Date.now() - new Date(ts).getTime();
  const m = Math.floor(diff / 60000);
  if (m < 1) return 'just now';
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 30) return `${d}d ago`;
  return new Date(ts).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};
